import { render, staticRenderFns } from "./GetMovieCharacters.vue?vue&type=template&id=1e3c35fc&scoped=true&"
import script from "./GetMovieCharacters.vue?vue&type=script&lang=js&"
export * from "./GetMovieCharacters.vue?vue&type=script&lang=js&"
import style0 from "./GetMovieCharacters.vue?vue&type=style&index=0&id=1e3c35fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c35fc",
  null
  
)

export default component.exports